import { Box, Divider, Skeleton, Stack } from '@mui/material';
import { FC } from 'react';

const CallForwardingRulesSkeleton: FC = () => {
  return (
    <Stack spacing={3}>
      {/* Header Skeleton */}
      <Box>
        <Skeleton variant="text" width={200} height={24} sx={{ mb: 0.5 }} />
        <Skeleton variant="text" width={400} height={20} />
      </Box>

      <Divider />

      {/* Default Fallback Number Skeleton */}
      <Box
        sx={{
          backgroundColor: '#F8F9FC',
          padding: 2,
          borderRadius: '8px',
          border: '1px solid #E0E0E0',
        }}
      >
        <Skeleton variant="text" width={180} height={20} sx={{ mb: 1 }} />
        <Skeleton variant="text" width={320} height={16} sx={{ mb: 1.5 }} />
        <Skeleton
          variant="rectangular"
          width="100%"
          height={40}
          sx={{ borderRadius: '6px' }}
        />
      </Box>

      {/* Rule Card Skeletons */}
      {[1, 2].map(index => (
        <Box
          key={index}
          sx={{
            border: '1px solid #E0E0E0',
            borderRadius: '8px',
            padding: 2,
            backgroundColor: '#FFFFFF',
          }}
        >
          {/* Rule Header */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mb: 2,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Skeleton variant="text" width={60} height={20} />
              <Skeleton
                variant="rectangular"
                width={36}
                height={20}
                sx={{ borderRadius: '10px' }}
              />
            </Box>
            <Skeleton
              variant="rectangular"
              width={40}
              height={40}
              sx={{ borderRadius: '8px' }}
            />
          </Box>

          <Stack spacing={2}>
            {/* Forward to Number */}
            <Box>
              <Skeleton variant="text" width={140} height={20} sx={{ mb: 1 }} />
              <Skeleton
                variant="rectangular"
                width="100%"
                height={40}
                sx={{ borderRadius: '6px' }}
              />
            </Box>

            {/* Timezone */}
            <Box>
              <Skeleton variant="text" width={100} height={20} sx={{ mb: 1 }} />
              <Skeleton
                variant="rectangular"
                width="100%"
                height={40}
                sx={{ borderRadius: '6px' }}
              />
            </Box>

            {/* Time Range */}
            <Box>
              <Skeleton variant="text" width={120} height={20} sx={{ mb: 1 }} />
              <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                <Skeleton variant="rectangular" sx={{ flex: 1 }} height={40} />
                <Skeleton variant="text" width={20} height={20} />
                <Skeleton variant="rectangular" sx={{ flex: 1 }} height={40} />
              </Box>
            </Box>

            {/* Secondary Forwarding */}
            <Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  mb: 1.5,
                }}
              >
                <Skeleton variant="text" width={220} height={20} />
                <Skeleton
                  variant="rectangular"
                  width={36}
                  height={20}
                  sx={{ borderRadius: '10px' }}
                />
              </Box>
            </Box>

            {/* Active Days */}
            <Box>
              <Skeleton variant="text" width={100} height={20} sx={{ mb: 1 }} />
              <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 1 }}>
                {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map(day => (
                  <Skeleton
                    key={day}
                    variant="rectangular"
                    width={52}
                    height={36}
                    sx={{ borderRadius: '8px' }}
                  />
                ))}
              </Box>
              <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                <Skeleton variant="text" width={60} height={20} />
                <Skeleton variant="text" width={70} height={20} />
                <Skeleton variant="text" width={65} height={20} />
              </Box>
            </Box>
          </Stack>
        </Box>
      ))}

      {/* Add New Rule Button Skeleton */}
      <Skeleton
        variant="rectangular"
        width="100%"
        height={48}
        sx={{ borderRadius: '8px' }}
      />

      {/* Save Button Skeleton */}
      <Skeleton
        variant="rectangular"
        width={240}
        height={44}
        sx={{ borderRadius: '6px' }}
      />

      {/* How it works section Skeleton */}
      <Box
        sx={{
          backgroundColor: '#F8F9FC',
          padding: 2,
          borderRadius: '8px',
          border: '1px solid #E0E0E0',
        }}
      >
        <Skeleton variant="text" width={120} height={20} sx={{ mb: 1.5 }} />
        <Stack spacing={0.5}>
          {[1, 2, 3, 4, 5].map(i => (
            <Skeleton key={i} variant="text" width="90%" height={18} />
          ))}
        </Stack>
      </Box>
    </Stack>
  );
};

export default CallForwardingRulesSkeleton;
